
export const text = `

http://farragofiction.com/TwoGayJokes/an_unsent_letter
    



`